import React, { useEffect } from 'react'
import Navigation from '../../../Components/Navigation/Navigation'
import Footer from '../../../Components/Footer/Footer'
import Hero from './Sections/Hero/Hero'
import IndustryChallengesAndSolutions from './Sections/IndustryChallengesAndSolutions/IndustryChallengesAndSolutions'
import IndustryTech from './Sections/IndustryTech/IndustryTech'
import AISearch from './Sections/AISearch/AISearch'
import SpecializedServices from './Sections/SpecializedServices/SpecializedServices'
import WhyChoose from './Sections/WhyChoose/WhyChoose'
import FAQ from '../../../Components/FAQ/FAQ'
import Aos from 'aos'
import 'aos/dist/aos.css'
import s1 from '../../../assets/images/s1.png'
import s2 from '../../../assets/images/s2.png'
import s8 from '../../../assets/images/s8.png'
import ClientSpeak from '../../Home/Components/ClientSpeak'
import GetQuote from '../../../Components/GetQuote/GetQuote'
import Contect from '../../Home/Components/Contect'
import CaseStudies from '../../Home/Components/CaseStudies'

const SocialMedia = () => {

	useEffect(() => {
		Aos.init({
			duration: 1000,
			once: true,
			offset: 100,
		});
	}, []);

	const homeContent = {
		title: 'Social Media App Development',
		description: 'The reason behind most social media applications crashing is that they pursue features rather than addressing real issues. They squander money on fancy interfaces and ignore user retention, content quality, and community building. Without genuine value or sticky engagement loops, users abandon ship when the novelty fades, leaving founders with expensive lessons.',
		image: s1,
		breadcrumb: 'Social Media',
		b: 'Build the Best Solution'
	}

	const industryChallengesAndSolutionsContent = {
		challengesTitle: 'The Fatal Mistakes Killing Social Media Startups',
		solutionsTitle: 'The Game-Changing Strategies That Build Viral Platforms',
		challenges: [
			{
				title: 'Your User Data Is a Sitting Duck for Hackers',
				description: 'Basic security gets you hacked fast. One data breach kills user trust instantly, triggers lawsuits, and destroys your startup before you can say "password123."',
				icon: '/images/industries/socialmedia/01.svg',
			},
			{
				title: 'Generic Features That Bore Users to Death',
				description: 'Another messaging app with filters? Users can\'t tell you apart from fifty others, so they delete yours within days of downloading.',
				icon: '/images/industries/socialmedia/02.svg',
			},
			{
				title: 'Content Moderation Nightmares Destroying Your Brand',
				description: 'Toxic posts spread faster than you can delete them. Your fun app becomes a PR disaster, scaring away users, investors, and app store reviewers.',
				icon: '/images/industries/socialmedia/03.svg',
			},
			{
				title: 'Apps That Can\'t Handle Growth Spikes',
				description: 'Going viral breaks your servers? Game over. Users won\'t give second chances—they\'ll download your competitor\'s working app instead.',
				icon: '/images/industries/socialmedia/04.svg',
			},
			{
				title: 'User Engagement Falls Off a Cliff After Week One',
				description: 'No personalized feeds or smart notifications means users forget you exist. Downloads don\'t matter if nobody sticks around.',
				icon: '/images/industries/socialmedia/05.svg',
			},
		],
		solutions: [
			{
				title: 'Bulletproof Security That Users Actually Trust',
				description: 'Military-grade encryption, zero-trust architecture, and regular penetration testing keep data locked down tight. Users sleep easy knowing their info is safe.',
				icon: '/images/industries/socialmedia/06.svg',
			},
			{
				title: 'Unique Features That Create Addictive User Experiences',
				description: 'Smart personalization, innovative interaction mechanics, and signature features nobody else has—experiences users can\'t help but share.',
				icon: '/images/industries/socialmedia/07.svg',
			},
			{
				title: 'AI-Powered Moderation That Actually Works',
				description: 'Toxic content is detected and blocked in real time. Models learn your community standards and keep discussions healthy automatically.',
				icon: '/images/industries/socialmedia/08.svg',
			},
			{
				title: 'Scalable Architecture That Handles Millions',
				description: 'Cloud-native infrastructure auto-scales during viral moments. Your app stays lightning-fast from thousands to millions of concurrent users.',
				icon: '/images/industries/socialmedia/09.svg',
			},
			{
				title: 'Engagement Mechanics That Drive Daily Return',
				description: 'Personalized notifications, streaks, and group features that create real FOMO—users return because they don\'t want to miss out.',
				icon: '/images/industries/socialmedia/10.svg',
			},
		]
	}

	const industryTechContent = {
		mainTitle: 'The Technology Stack that Powers the Hottest Apps Today',
		leftHeading: 'Harnessing Advanced Technologies For Social Media App Development',
		leftParagraph: 'We use ML-driven personalization, low-latency streaming, and social commerce systems to power engaging, scalable social platforms that convert attention into growth.',
		leftImage: s2,
		performanceItems: [
			{
				title: 'Machine Learning to Build Custom Content Feeds',
				description: 'Algorithms learn user behavior to deliver endless, hyper-relevant content that drives sky-high engagement.',
				icon: '/images/industries/socialmedia/12.svg',
			},
			{
				title: 'Real-Time Video & Live Streaming Infrastructure',
				description: 'Low-latency streaming provides crystal-clear video with smooth interactions—no buffering, no drop-offs.',
				icon: '/images/industries/socialmedia/13.svg',
			},
			{
				title: 'Hyper-Personalized Feed Recommendation Algorithms',
				description: 'AI uses micro-interactions to anticipate the next post each user wants—keeping sessions sticky and long.',
						icon: '/images/industries/socialmedia/14.svg',
			},
			{
				title: 'Smooth Social Commerce / In-App Shopping',
				description: 'Single-tap buying with secure checkout and social proof turns window shoppers into instant buyers.',
				icon: '/images/industries/socialmedia/15.svg',
			},
		]
	};

	const aiSearchContent = {
		mainTitle: 'The Complete Social Media Platform That Users Crave',
		sections: [
			{
				title: 'Intelligent Content Discovery Engine',
				description: 'AI studies every tap, swipe, and pause to deliver feeds that feel personally crafted for each user in real time.',
				image: '/images/industries/socialmedia/s3.png',
				imageAlt: 'Intelligent Content Discovery Engine',
				imagePosition: 'left',
				features: [
					'AI trained on micro-interactions like pause time and scroll speed',
					'Context-aware timing based on mood and time of day',
					'Smart trending detection before content peaks elsewhere',
					'Hashtag and topic suggestions aligned to interests',
					'Blended photo, video, and text content in one feed',
					'Real-time optimization that adapts instantly',
				],
			},
			{
				title: 'Advanced Video & Story Features',
				description: 'Creation tools that make everyone feel like a pro—boosting posting frequency and content quality without the learning curve.',
				image: '/images/industries/socialmedia/s4.png',
				imageAlt: 'Advanced Video & Story Features',
				imagePosition: 'right',
				features: [
					'One-tap editing with pro filters and transitions',
					'Smooth AR effects and face filters across devices',
					'Story templates for quick, engaging posts',
					'Smart compression for crisp, fast-loading videos',
					'Collaborative editing for real-time co-creation',
					'Auto-captions and accessibility built-in',
				],
			},
			{
				title: 'Community Building & Group Management',
				description: 'Tools that turn random users into tight-knit tribes with strong identities and healthy, self-sustaining culture.',
				image: '/images/industries/socialmedia/s5.png',
				imageAlt: 'Community Building & Group Management',
				imagePosition: 'left',
				features: [
					'Smart group discovery to match users with communities',
					'Intuitive moderation for healthy conversations',
					'Event planning that bridges online and offline',
					'Reputation systems rewarding positive behavior',
					'Nested threads for organized discussions',
					'Branding tools for unique group identity',
				],
			},
			{
				title: 'Real-Time Messaging & Voice Chat',
				description: 'Messaging that feels alive: large groups, instant status, smart notifications, and spatial audio rooms.',
				image: '/images/industries/socialmedia/s6.png',
				imageAlt: 'Real-Time Messaging & Voice Chat',
				imagePosition: 'right',
				features: [
					'Crystal-clear voice with noise cancellation',
					'Group chats with hundreds of participants',
					'Instant typing indicators and message states',
					'Smart notification management to reduce noise',
					'Spatial audio rooms for natural group talk',
					'Emojis and reactions that feel expressive',
				],
			},
			{
				title: 'Analytics Dashboard for Creators & Brands',
				description: 'Actionable insights for growth—no data science required. Turn charts into decisions that expand reach and revenue.',
				image: '/images/industries/socialmedia/s7.png',
				imageAlt: 'Analytics Dashboard for Creators & Brands',
				imagePosition: 'left',
				features: [
					'On-the-fly engagement reporting to see what\'s working',
					'Demographic breakdowns to reveal new segments',
					'Trend prediction to stay ahead of waves',
					'ROI tracking that proves budget effectiveness',
					'Content comparisons to learn what wins',
					'Automated reports that deliver clear insights',
				],
			},
		],
	};

	const servicesContent = {
		title: 'The Development Services That Launch Viral Success Stories',
		cards: [
			{
				icon: '/images/industries/socialmedia/16.svg',
				title: 'Custom Algorithm Development',
				description: 'We build recommendation engines that learn user behavior patterns, creating addictive feeds that keep audiences scrolling for hours daily.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/socialmedia/17.svg',
				title: 'High-Performance Backend Architecture',
				description: 'Lightning-fast APIs and optimized databases handle millions of simultaneous users without crashes or slowdowns.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/socialmedia/18.svg',
				title: 'Cross-Platform Mobile Development',
				description: 'Native iOS and Android apps that feel buttery smooth while delivering platform-specific experiences users love.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/socialmedia/19.svg',
				title: 'Content Delivery Network Integration',
				description: 'Global CDNs serve videos and images instantly worldwide, eliminating buffering that drives users away.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/socialmedia/20.svg',
				title: 'Advanced Security & Privacy Systems',
				description: 'Military-grade encryption and active threat detection build trust and convert downloads into loyalty.',
				buttonText: 'Discover More',
			},
			{
				icon: '/images/industries/socialmedia/16.svg',
				title: 'Scalable Cloud Infrastructure',
				description: 'Auto-scaling infrastructure adapts to viral spikes seamlessly, keeping your app online when it matters most.',
				buttonText: 'Discover More',
			},
		],
	};

	const whyChooseContent = {
		title: "Why Tomorrow's Social Media Giants Choose Our Development Team",
		image: s8,
		imageAlt: 'Why Choose Us for Social Media App Development',
		items: [
			{
				title: 'Proven Track Record in Viral App Development',
				desc: 'We\'ve launched platforms hitting million-user milestones within months and sustaining growth.',
			},
			{
				title: 'Platforms Engineered to Grow Exponentially',
				desc: 'Architecture that absorbs sudden traffic bursts and turns viral moments into long-term growth.',
			},
			{
				title: 'Security That Survives Public Scrutiny',
				desc: 'Bank-level encryption and privacy controls that pass rigorous audits and protect your reputation.',
			},
			{
				title: 'Code Architecture That Scales to Millions',
				desc: 'Clean, modular code that evolves from startup to enterprise without expensive rewrites.',
			},
			{
				title: 'Developers Who Understand Social Media Psychology',
				desc: 'We build healthy engagement loops that feel natural and create lasting affinity.',
			},
		],
	};

	const faqContent = {
		title: "Got Questions? We've Got Answers",
		questions: [
			{
				q: 'How do you ensure our app will achieve viral growth?',
				a: 'We engineer engagement loops, seamless sharing flows, and personalized experiences that organically motivate users to invite friends.'
			},
			{
				q: 'What\'s your approach to content moderation and user safety?',
				a: 'AI-powered real-time scanning combined with expert human review keeps spaces safe without stifling authentic conversation.'
			},
			{
				q: 'What about enormous user scale and server scaling?',
				a: 'Auto-scaling cloud infrastructure expands with traffic bursts to keep your app online during viral moments.'
			},
			{
				q: 'What monetization will you add to our platform?',
				a: 'In-app purchases, creator monetization, sponsored content, and social commerce that blends naturally with user flow.'
			}
		]
	};

	return (
		<>
			<Navigation offer={true} />
			<Hero homeContent={homeContent} />
			<div data-aos="fade-up">
				<IndustryChallengesAndSolutions industryChallengesAndSolutionsContent={industryChallengesAndSolutionsContent} />
			</div>
			<div data-aos="fade-up">
				<IndustryTech industryTechContent={industryTechContent} />
			</div>
			<div data-aos="fade-up">
				<AISearch aiSearchContent={aiSearchContent} />
			</div>
			<div data-aos="fade-up">
				<SpecializedServices servicesContent={servicesContent} />
			</div>
			<div data-aos="fade-up">
				<WhyChoose whyChooseContent={whyChooseContent} />
			</div>
			<div data-aos="fade-up">
                <CaseStudies />
            </div>
            <div data-aos="fade-up">
                <ClientSpeak />
            </div>
            <div data-aos="fade-up">
                <GetQuote />
            </div>
			<div data-aos="fade-up">
				<FAQ faqContent={faqContent} />
			</div>
            <div data-aos="fade-up">
                <Contect />
            </div>
			
			<Footer />
		</>
	)
}

export default SocialMedia


